type PaginationQueryParams = Partial<{
  page: number | string;
  count: number | string;
}>;

/**
 * Takes an incoming hydrate state query (usually parsed from query params)
 * and validates that the pagination portions are valid numbers.
 *
 * @param {Query} query - A HydrateStateQuery, pulled from qs.parse
 */
export const parsePaginationQueryParams =
  <Query extends PaginationQueryParams>(query: Partial<Query>): Partial<Query> => {
    const parsed: Partial<Query> = {};

    if (query.count) {
      const numericCount = Number(query.count);
      if (Number.isFinite(numericCount)) {
        parsed.count = numericCount;
      }
    }

    if (query.page) {
      const numericPage = Number(query.page);
      if (Number.isFinite(numericPage)) {
        parsed.page = numericPage;
      }
    }

    return parsed;
  };
